@let isHighlightedServicesTest = isHighlightedServicesTest$ | async;
<div class="pr-small-x pr-small-t pr-xsmall-b">
  <fin-grouped-services
    *ngIf="filteredGroupedServices.length > 0"
    class="block pr-xsmall-b border-bottom"
    [groupedServices]="filteredGroupedServices"
  ></fin-grouped-services>

  <ng-container *ngIf="!hideSelection">
    <div class="flex flex--middle" [class.pr-xsmall-t]="filteredGroupedServices.length > 0">
      @if (isHighlightedServicesTest) {
        <div class="font-body-1 medium-type" data-testid="ancillaries-subtitle-highlighted-services">
          {{
            (ancillaries.length > 0
              ? 'ancillaries.productList.subtitle.added'
              : isHighlightedServicesAvailable
                ? 'ancillaries.productList.subtitle.topPick'
                : 'ancillaries.productList.subtitle.generic'
            ) | finLocalization
          }}
        </div>
      } @else {
        <fcom-icon [name]="SvgLibraryIcon.CHECKMARK" class="icon-medium ms-xsmall-r"></fcom-icon>
        <div class="font-body-1 medium-type">{{ 'ancillaries.selectionText' | finLocalization }}</div>
      }
    </div>

    <div class="flex" *ngIf="ancillaries.length">
      <div class="flex-4 align-left">
        <ul class="accommodate-icon list-disc-style">
          <li *ngFor="let ancillary of ancillaries">
            <span *ngIf="ancillary.quantity > 1">{{ ancillary.quantity }} x </span>

            <span data-testid="ancillary-selection-title">
              @if (ancillary.category === Category.BUNDLE) {
                @let bundle = ancillary.bundleServiceData$ | async;
                {{
                  'ancillaries.bundle.selectionTitle.' + ancillary.subCategory
                    | finLocalization
                      : {
                          seatType: bundle?.seatTypeLabel | finLocalization,
                          seatNumber: bundle?.seatNumber,
                          includedProduct: bundle?.includedProduct,
                        }
                    | finEmpty: ancillary.translations.title
                }}
              } @else {
                {{ ancillary.translations.title }}
              }
            </span>

            <span *ngIf="ancillary.originalPrice">
              <span class="strike-through">{{ ancillary.originalPrice | finPrice }}</span></span
            >
            <span class="heather-700-text" *ngIf="ancillary.totalPrice && +ancillary.totalPrice?.amount !== 0">
              {{ ancillary.totalPrice | finPrice }}</span
            >
          </li>
        </ul>
      </div>
      <div class="flex-1 align-right" *ngIf="showRemoveBasedOnAncillaries">
        <fcom-button
          [aria]="{ describedby: 'ancillaries-total-price' }"
          [icon]="{
            name: SvgLibraryIcon.CLOSE_DELETE,

            position: IconPosition.LEFT,
          }"
          [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
          [text]="'ancillaries.removeSelections' | finLocalization"
          (clickBtn)="removeSelections.emit($event)"
        ></fcom-button>
      </div>
    </div>
  </ng-container>
</div>
